// wartsRemovalData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const wartsRemoval: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Warts Removal in Dubai | Safe & Effective Treatment",
            "description": "Warts removal in Dubai is a safe and effective treatment for your skin. At Elite Body Home, we offer advanced facial wart removal to achieve clear, smooth skin.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/warts-removal-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Warts Removal in Dubai | Safe & Effective Treatment",
                "description": "Warts removal in Dubai is a safe and effective treatment for your skin. At Elite Body Home, we offer advanced facial wart removal to achieve clear, smooth skin.",
                "url": "https://elitebodyhome.com/services/warts-removal-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-02-13T14:08:15+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Warts-Removal-Dubai-13-scaled-large.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Warts-Removal-Dubai-13-scaled-large.jpg",
                "image_width": 1024,
                "image_height": 320,
                "image_alt": "Warts Removal",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Warts Removal in Dubai | Safe & Effective Treatment",
                "description": "Warts removal in Dubai is a safe and effective treatment for your skin. At Elite Body Home, we offer advanced facial wart removal to achieve clear, smooth skin.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Warts-Removal-Dubai-13-scaled-large.jpg"
            },

        },
        "breadcrumbs": ["Home", "Services", "Warts Removal Dubai"],
        "hero": {
            "title": "Warts Removal Dubai",
            "subtitle": "Clear Away Warts for Smooth, Healthy Skin",
            "description": "Warts are a usual skin disorder due to human papillomavirus (HPV), and producing unsightly, rough barnacles on skin. Warts are typically harmless but may be painful, uncomfortable, or embarrassing, and their removal is many patients' priority. At Elite Body Home Polyclinic advanced techniques for wart removal provide effective, safe, and rapid relief from this condition."
        },
        "howItWorks": {
            "title": "",
            "description": ""
        },
        "procedureSteps": {
            "heading": "Procedure",
            "para": "Wart removal is a process that removes warts by multiple techniques, depending on the size, type, and location of the wart. These include cryotherapy, laser removal, electrosurgery, and topical treatments. Both methods are performed with precision to avoid damage to healthy skin surrounding the wart.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Here, a dermatologist investigates the wart to determine the best treatment option depending on its type, size, and location.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Cryotherapy",
                    "desc": "Froze the wart completely with liquid nitrogen so that it will eventually fall off once that tissue dies — this usually takes several sessions.",
                    "icon": "fa-solid fa-temperature-low"
                },
                {
                    "title": "Salicylic Acid Treatment",
                    "desc": "A slow, topical treatment that breaks down and removes the wart layer by layer, over the course of weeks.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "Electrosurgery",
                    "desc": "Utilizes an electric current to destroy the wart, frequently in conjunction with curettage for complete removal.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Surgical Excision",
                    "desc": "A surgery is performed to cut the wart, which is a method that is done in large or persistent cases under local anesthesia.",
                    "icon": "fa-solid fa-scalpel"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "TOP 5 BENEFITS OF WART REMOVAL",
            "para": "Getting rid of warts makes the skin look better, and prevents them from spreading and causing more misery. Wart removal definitely has many benefits which improve both skin health and confidence.",
            "items": [
                {
                    "title": "Improved Appearance",
                    "desc": "Remove unsightly warts and regain smooth skin.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Pain Relief",
                    "desc": "Warts located on the soles of the feet or other sensitive regions can lead to discomfort and irritation; their removal relieves the issues they create.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Prevents Spread",
                    "desc": "Warts can easily spread to other areas of the body, or to other people. Removal reduces this risk.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Boosts Confidence",
                    "desc": "Remove embarrassing warts that lower your self-esteem.",
                    "icon": "fa-solid fa-smile"
                },
                {
                    "title": "Minimal Downtime",
                    "desc": "Most procedures promote rapid recovery with little interruption to day-to-day life.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Although removal of warts is appropriate for the majority of people, some conditions can make you ineligible for certain treatments. You must reach out to a bona fide group of medical experts and understand the relevant steps based on the type of skin, medical history and nature of the warts.",
            "items": [
                {
                    "title": "People with stubborn warts",
                    "desc": "that haven't resolved with over-the-counter treatments.",
                    "icon": "fa-solid fa-exclamation"
                },
                {
                    "title": "Patients experiencing discomfort",
                    "desc": "or pain as a result of warts.",
                    "icon": "fa-solid fa-thermometer-half"
                },
                {
                    "title": "Those susceptible to chronic warts",
                    "desc": "as professional treatment lessens the likelihood of subsequent growth.",
                    "icon": "fa-solid fa-redo"
                },
                {
                    "title": "Individuals with compromised immune systems",
                    "desc": "or individuals more prone to the spread of warts.",
                    "icon": "fa-solid fa-shield-virus"
                },
                {
                    "title": "Aesthetic reasons",
                    "desc": "for wanting to remove it.",
                    "icon": "fa-solid fa-paint-brush"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Hence, wart removal procedure is smooth and very effective. Here are some things you might have to do before the treatment.",
            "items": [
                {
                    "title": "Consultation",
                    "desc": "A dermatologist consult will decide the proper approach for removal.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Avoid self-treatment",
                    "desc": "Never try to treat or remove warts yourself because it can lead to infection or scarring.",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "Clean the area",
                    "desc": "Ensure that the area around the wart is clean and not irritated.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "Disclose medical history",
                    "desc": "Tell your provider about any underlying conditions or medications you are on.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "The good news is that successful wart removal leaves behind smooth, wart-free skin and greatly lowers the chances of spreading or regrowth. Results are often lasting, but follow-up care may be needed for recurrent cases. Healing occurs over several weeks, and new, healthy skin will form in place of the wart tissue.",
            "items": [
                {
                    "title": "Immediate Relief",
                    "desc": "The pain or discomfort from warts will be gone nearly immediately after the treatment.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "Healing Time",
                    "desc": "Depending which removal method you need, the treated area will heal in 1-2 weeks.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "Reduced Recurrence",
                    "desc": "When treated professionally, the risk of wart recurrence is considerably lower.",
                    "icon": "fa-solid fa-chart-line-down"
                },
                {
                    "title": "Follow-up Visits",
                    "desc": "Sometimes a follow up appointment is required to ensure that the wart has gone completely.",
                    "icon": "fa-solid fa-calendar-plus"
                }
            ]
        },
        // "aftercareTips": {
        //     "heading": "Effective Aftercare",
        //     "subheading": "",
        //     "para": "Post procedure care is important for healing and prevents infections and recurrences as well",
        //     "items": [
        //         {
        //             "title": "",
        //             "desc": "",
        //             "icon": ""
        //         }
        //     ]
        // },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Does wart removal hurt?",
                    "answer": "Wart removal procedures, like cryotherapy or laser removal, may cause mild discomfort or a stinging sensation, but numbing options are available to reduce pain. Most patients report only minimal pain."
                },
                {
                    "question": "How long does the wart removal process take?",
                    "answer": "The process is usually quick, lasting 15-30 minutes depending on the size and number of warts being treated. Some warts may require multiple sessions for complete removal."
                },
                {
                    "question": "Will the wart come back after treatment?",
                    "answer": "While most treatments effectively remove warts, HPV remains in the body, so new warts can appear. Proper aftercare and follow-up treatments help minimize recurrence."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Minor side effects may include redness, swelling, or a blister at the treatment site. These are temporary and usually resolve within a few days."
                },
                {
                    "question": "Is wart removal safe?",
                    "answer": "Yes, wart removal is generally safe when performed by trained professionals. Our clinicians follow strict safety protocols to minimize risks and ensure effective results."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Warts-Removal-Dubai-13-scaled-large.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Warts-Removal-Dubai-1.jpg",
                'https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Warts-Removal-Dubai-2.jpg',
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Warts-Removal-Dubai-3.jpg"
            ]
        },
        "product": {
            "id": 123,
            "title": "Warts Removal",
            "price": 399,
            "description": "Warts removal in Dubai is a safe and effective treatment for your skin. At Elite Body Home, we offer advanced facial wart removal to achieve clear, smooth skin."
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "إزالة الثآليل في دبي | علاج آمن وفعال",
            "description": "إزالة الثآليل في دبي علاج آمن وفعال لبشرتك. في عيادة إيليت بودي هوم، نقدم إزالة متقدمة لثآليل الوجه للحصول على بشرة ناعمة وصافية.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/ar/services/warts-removal-dubai/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "إزالة الثآليل في دبي | علاج آمن وفعال",
                "description": "إزالة الثآليل في دبي علاج آمن وفعال لبشرتك. في عيادة إيليت بودي هوم، نقدم إزالة متقدمة لثآليل الوجه للحصول على بشرة ناعمة وصافية.",
                "url": "https://elitebodyhome.com/ar/services/warts-removal-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-02-13T14:08:15+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Warts-Removal-Dubai-13-scaled-large.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Warts-Removal-Dubai-13-scaled-large.jpg",
                "image_width": 1024,
                "image_height": 320,
                "image_alt": "إزالة الثآليل",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "إزالة الثآليل في دبي | علاج آمن وفعال",
                "description": "إزالة الثآليل في دبي علاج آمن وفعال لبشرتك. في عيادة إيليت بودي هوم، نقدم إزالة متقدمة لثآليل الوجه للحصول على بشرة ناعمة وصافية.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Warts-Removal-Dubai-13-scaled-large.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "إزالة الثآليل في دبي"],
        "hero": {
            "title": "إزالة الثآليل في دبي",
            "subtitle": "تخلص من الثآليل واحصل على بشرة ناعمة وصحية",
            "description": "الثآليل هي خلل جلدي شائع ناتج عن فيروس الورم الحليمي البشري (HPV)، وتظهر على شكل نتوءات خشنة ومزعجة على سطح الجلد. وعلى الرغم من أن الثآليل غالبًا ما تكون غير ضارة، إلا أنها قد تكون مؤلمة أو مزعجة أو تسبب الإحراج، لذلك تُعد إزالتها أولوية للكثير من المرضى. نقدم في ايليت بودي هوم تقنيات متطورة لإزالة الثآليل بسرعة وفعالية وتوفر راحة سريعة من هذه الحالة."
        },
        "howItWorks": {
            "title": "",
            "description": ""
        },
        "procedureSteps": {
            "heading": "الإجراء",
            "para": "يتم التخلص من الثآليل باستخدام تقنيات متعددة، وذلك حسب حجم الثآليل ونوعها ومكانها في الجسم. تشمل هذه التقنيات العلاج بالتبريد (الكرايوثيرابي)، والعلاج بالليزر، والعلاج بالجراحة الكهربائية، والعلاج الموضعي. تُنفذ جميع الطرق بدقة عالية لتجنب إلحاق الضرر بالجلد السليم المحيط بالثآليل.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يقوم طبيب الجلدية بفحص الثؤلول لتحديد الخيار العلاجي الأنسب بناءً على نوعه وحجمه ومكان تواجده.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "العلاج بالتبريد",
                    "desc": "يتم تجميد الثؤلول تمامًا باستخدام النيتروجين السائل، ما يؤدي إلى موت النسيج أو سقوطه، وغالبًا ما يتطلب الأمر عدة جلسات.",
                    "icon": "fa-solid fa-temperature-low"
                },
                {
                    "title": "العلاج بحمض الساليسيليك",
                    "desc": "يُعد العلاج بحمض الساليسيليك علاج موضعي بطيء، يُستخدم لتفتيت وإزالة الثؤلول طبقة بعد طبقة على مدار عدة أسابيع.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "العلاج بالجراحة الكهربائية",
                    "desc": "يُستخدم تيارًا كهربائيًا لتدمير الثؤلول، وغالبًا ما يُستخدم مع الكشط لإزالة الثؤلول بالكامل.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "الاستئصال الجراحي",
                    "desc": "يُجرى استئصال جراحي لقطع الثؤلول، وتُستخدم هذه الطريقة عادة في الحالات الكبيرة أو المتكررة، وتُجرى باستخدام تخدير موضعي.",
                    "icon": "fa-solid fa-scalpel"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد",
            "subheading": "أهم 5 فوائد لإزالة الثآليل",
            "para": "لا يُحسّن إجراء إزالة الثآليل من مظهر الجلد فحسب، بل يمنع أيضًا انتشارها وتجنب المزيد من المعاناة. توفر إزالة الثآليل العديد من الفوائد التي تُسهم في تحسين صحة الجلد وتعزيز الثقة بالنفس.",
            "items": [
                {
                    "title": "تحسين المظهر",
                    "desc": "يساعد التخلص من الثآليل غير المرغوب بها في استعادة نعومة الجلد ومنحه مظهرًا صحيًا.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "تخفيف الآلام",
                    "desc": "قد تسبب الثآليل التي تظهر في باطن القدم أو المناطق الحساسة إزعاجًا وألمًا، ويخفف إزالتها من هذه الأعراض.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "الوقاية من الانتشار",
                    "desc": "تتمكن الثآليل من الانتقال بسهولة إلى مناطق أخرى من الجسم أو إلى أشخاص آخرين، ويُقلل إزالتها من هذا الخطر.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "زيادة الثقة بالنفس",
                    "desc": "يُساعدك إزالة الثآليل المحرجة على استعادة ثقتك بنفسك ومظهرك العام.",
                    "icon": "fa-solid fa-smile"
                },
                {
                    "title": "لا يتطلب فترة تعافي طويلة",
                    "desc": "تُتيح معظم الإجراءات الشفاء السريع دون التأثير على روتين الحياة اليومي.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "على الرغم من أن علاج إزالة الثآليل مناسب لمعظم الأشخاص، إلا أن بعض الحالات قد تجعل بعض الخيارات العلاجية غير مناسبة. يجب استشارة مجموعة موثوقة من الأطباء المتخصصين، لفهم الخطوات المناسبة حسب نوع الجلد، والتاريخ الطبي، وطبيعة الثآليل.",
            "items": [
                {
                    "title": "الأشخاص الذين يعانون من ثآليل مستعصية",
                    "desc": "لم تستجب للعلاج المتوفر دون وصفة طبية.",
                    "icon": "fa-solid fa-exclamation"
                },
                {
                    "title": "المرضى الذين يشعرون بالانزعاج",
                    "desc": "أو الألم بسبب الثآليل.",
                    "icon": "fa-solid fa-thermometer-half"
                },
                {
                    "title": "الأشخاص المعرضين لتكرار ظهور الثآليل",
                    "desc": "حيث يساعد العلاج المتخصص في تقليل احتمالية نموها من جديد.",
                    "icon": "fa-solid fa-redo"
                },
                {
                    "title": "الأفراد الذين يعانون من ضعف في جهاز المناعة",
                    "desc": "أو من لديهم قابلية أعلى لانتشار الثآليل.",
                    "icon": "fa-solid fa-shield-virus"
                },
                {
                    "title": "الأسباب الجمالية",
                    "desc": "للأشخاص الذين يرغبون بإزالة الثآليل لأسباب تتعلق بالمظهر الجمالي.",
                    "icon": "fa-solid fa-paint-brush"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يُنصح باتباع بعض الخطوات قبل الخضوع للعلاج، لضمان إجراء إزالة الثآليل بسلاسة وفعالية.",
            "items": [
                {
                    "title": "الاستشارة",
                    "desc": "ستحدد استشارة الطبيب الجلدي نوع العلاج المناسب لإزالة الثآليل.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "تجنب المعالجة الذاتية",
                    "desc": "لا تحاول إزالة أو معالجة الثآليل بنفسك؛ لأن ذلك قد يؤدي ذلك إلى عدوى أو ظهور ندبات.",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "تنظيف المنطقة",
                    "desc": "احرص على أن تكون المنطقة المحيطة بالثؤلول نظيفة وغير ملتهبة.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "الكشف عن التاريخ الطبي",
                    "desc": "أخبر طبيبك بأي حالات صحية مزمنة أو أدوية تستخدمها.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "إليك الخبر السار في هذا العلاج وهو أن الإجراء الناجح لإزالة الثآليل يؤدي إلى بشرة ناعمة وخالية من الثآليل، مع تقليل كبير لاحتمالية انتقالها أو عودتها. غالبًا ما تكون النتائج طويلة الأمد، ولكن قد تكون هناك حاجة إلى رعاية لاحقة للحالات المتكررة. تستغرق عملية الشفاء عدة أسابيع، حيث تتكون بشرة جديدة وصحية مكان الأنسجة المتأثرة.",
            "items": [
                {
                    "title": "الراحة الفورية",
                    "desc": "يختفي الألم أو الانزعاج الناتج عن الثآليل تقريبًا فور الانتهاء من العلاج.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "مدة الشفاء",
                    "desc": "يلتئم الجلد خلال أسبوع إلى أسبوعين، حسب نوع العلاج المستخدم.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "انخفاض معدل تكرار ظهور الثآليل",
                    "desc": "يقل خطر عودة الثآليل بشكل كبير، عند علاجها على يد متخصصين.",
                    "icon": "fa-solid fa-chart-line-down"
                },
                {
                    "title": "زيارات المتابعة",
                    "desc": "يُنصح بزيارة متابعة للتأكد من زوال الثؤلول تمامًا في بعض الحالات.",
                    "icon": "fa-solid fa-calendar-plus"
                }
            ]
        },
        // "aftercareTips": {
        //     "heading": "العناية الفعالة بعد العلاج",
        //     "subheading": "",
        //     "para": "تُعد العناية بعد الإجراء ضرورية لضمان التئام الجلد ومنع العدوى أو تكرار ظهور الثآليل.",
        //     "items": [
        //         {
        //             "title": "",
        //             "desc": "",
        //             "icon": ""
        //         }
        //     ]
        // },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل إزالة الثآليل مؤلمة؟",
                    "answer": "قد تسبب إجراءات إزالة الثآليل مثل العلاج بالتبريد أو الليزر إزعاجًا بسيطًا أو شعورًا بالوخز، ولكن تتوفر خيارات التخدير لتقليل الألم. معظم المرضى يبلغون عن ألم بسيط جدًا."
                },
                {
                    "question": "كم تستغرق عملية إزالة الثآليل؟",
                    "answer": "عادة ما تكون العملية سريعة، وتستغرق من 15 إلى 30 دقيقة حسب حجم وعدد الثآليل التي يتم علاجها. قد تتطلب بعض الثآليل جلسات متعددة للإزالة الكاملة."
                },
                {
                    "question": "هل ستعود الثآليل بعد العلاج؟",
                    "answer": "بينما تزيل معظم العلاجات الثآليل بشكل فعال، يبقى فيروس الورم الحليمي البشري في الجسم، لذلك قد تظهر ثآليل جديدة. تساعد العناية الصحيحة بعد العلاج والجلسات المتابعة في تقليل احتمالية العودة."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "قد تشمل الآثار الجانبية البسيطة احمرارًا أو تورمًا أو ظهور فقاعة في موقع العلاج. هذه آثار مؤقتة وتختفي عادةً خلال بضعة أيام."
                },
                {
                    "question": "هل إزالة الثآليل آمنة؟",
                    "answer": "نعم، تعتبر إزالة الثآليل آمنة بشكل عام عند إجرائها من قبل متخصصين مدربين. يتبع أطباؤنا بروتوكولات أمان صارمة لتقليل المخاطر وضمان نتائج فعالة."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};
